export * as updateSpaceRecordFunctionalUsage from './update-space-record-functional-usage'
